import { combineReducers } from "redux";
import { wishes } from "./wish";

export default combineReducers({
  wishes,
});